import stdLiveWrapper from "./hoc/stdLiveWrapper";
import StudentData from "./components/StudentData";
import DownloadData from "./components/DownloadData";
import StudentDataHybrid from "./components/StudentDataHybrid";
import DownloadDataHybrid from "./components/DownloadDataHybrid";

export const StdLive = stdLiveWrapper(StudentData, DownloadData, {
	paramName: "_id",
});

export const StdLiveHybrid = stdLiveWrapper(
	StudentDataHybrid,
	DownloadDataHybrid,
	{
		paramName: "_id",
	}
);
